import { withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import ConfirmacaoDialog from "./ConfirmacaoDialog";
import * as Actions from "./Store/Actions/ConfirmacaoActions";
import ConfirmacaoReducer from "./Store/Reducers/ConfirmacaoReducer";

const styles = () => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        height: "57px",
        border: "1px solid #d2d2d2",
    },
});

class ConfirmacaoApp extends XAPPComponent {

    onClick = (ev, _AID) => {
        const { openDialog, onConfirmation, data, checkBypass = null } = this.props;
        ev.stopPropagation();

        if (!_.isNull(checkBypass) && checkBypass()) {
            onConfirmation(ev, data);
        }
        else {
            openDialog(_AID);
        }
    };

    render() {
        const { tipoAcao, disabled, tooltip, onConfirmation, mensagem, label, icon, type, className, data, id, iconProps, color = "primary", children } = this.props;

        return (
            <React.Fragment>
                <XAPPButton
                    key={"XAPPButton_" + id}
                    type={type}
                    id={id}
                    tooltip={tooltip}
                    className={className}
                    variant="contained"
                    disabled={disabled}
                    color={color}
                    onClick={(ev) => this.onClick(ev, id)}
                    iconProps={iconProps}
                    icon={icon}
                    label={label}
                >
                    {children}
                </XAPPButton>
                <ConfirmacaoDialog
                    onConfirmation={onConfirmation}
                    mensagem={mensagem ?? "Mensagem de confirmação não implementada!"}
                    data={data}
                    id={id}
                    tipoAcao={tipoAcao}
                />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog
    }, dispatch);
}

function mapStateToProps({ ConfirmacaoApp }) {
    return {
        Confirmacao: ConfirmacaoApp,
    };
}

export default withReducer("ConfirmacaoApp", ConfirmacaoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmacaoApp))));
